import type { DriverRankingAppliedPenaltyEntity } from './DriverRankingAppliedPenaltyEntity'
import type { DriverRankingMetricBreakdownEntity } from './DriverRankingMetricBreakdownEntity'

export class DriverRankingDetailEntity {
  id?: string
  rankingPeriodId?: string
  driverId?: number
  driverFullName?: string | null
  driverAvatarImagePath?: string | null
  regionId?: number
  rankPosition?: number | null
  finalScore?: number
  tierConfigId?: string | null
  tierName?: string | null
  isRestricted?: boolean
  excludedReason?: string | null
  periodStartDate?: string
  periodEndDate?: string
  metricBreakdown?: DriverRankingMetricBreakdownEntity
  appliedPenalties?: DriverRankingAppliedPenaltyEntity[] | null
  createdAt?: string
  updatedAt?: string
}
